import { useState, useCallback, useEffect } from "react";

function fetchJson(url) {
  return fetch(url, {
    credentials: "same-origin",
    headers: { Accept: "application/json" },
  }).then((res) => res.json());
}

export default function useCables({ readOnly }) {
  const [powerCables, setPowerCables] = useState([]);
  const [signalCables, setSignalCables] = useState([]);
  const [cablesLoading, setCablesLoading] = useState(true);

  const fetchCables = useCallback(() => {
    if (readOnly) return;
    Promise.all([
      fetchJson("/api/cables?kind=power"),
      fetchJson("/api/cables?kind=signal"),
    ])
      .then(([power, signal]) => {
        setPowerCables(power);
        setSignalCables(signal);
      })
      .catch(() => {})
      .finally(() => setCablesLoading(false));
  }, [readOnly]);

  useEffect(() => {
    fetchCables();
  }, [fetchCables]);

  useEffect(() => {
    if (readOnly) return;
    const handler = () => fetchCables();
    document.addEventListener("catalog:refresh", handler);
    return () => document.removeEventListener("catalog:refresh", handler);
  }, [readOnly, fetchCables]);

  return { powerCables, signalCables, cablesLoading };
}
